import * as React from "react";
import { NativeBaseProvider } from "native-base";
import theme from "../../theme/generic-theme/generic-theme";
import { APIProvider } from "../../../api/common";
import colorModeManager from "../../../core/color-manager/color-mode-manager";
import { FirstTimeProvider } from "../../../core/use-is-first-time";

type Props = {
  children: React.ReactNode;
};

export default function AppContainer(props: Props) {



  return (
    <APIProvider>
      <FirstTimeProvider>
        <NativeBaseProvider colorModeManager={colorModeManager} theme={theme}>{props.children}</NativeBaseProvider>
      </FirstTimeProvider>
    </APIProvider>
    // </AuthProvider>
  );
}
